import { AppRoutingConstants } from "../app-routing.constants";
export class ViewApplicationRoutingConstants {
    static VIEW_APPLICATION_ROUTE = AppRoutingConstants.createRouteToView("view-application");
    static JOB_ID_ROUTE_PARAMETER = ":jobID";
    static VIEW_APPLICATION_HEADING_TEXT = "View application";
    static APPLICATION_CONTENT_ROUTE = AppRoutingConstants.createRouteToView("content");
    static APPLICATION_SUMMARY_ROUTE = AppRoutingConstants.createRouteToView("summary");
    static REQUIRED_DOCS = AppRoutingConstants.createRouteToView("documentation");
    static LOCATION_ROUTE = AppRoutingConstants.createRouteToView("location");
    static DETAILS_ROUTE = AppRoutingConstants.createRouteToView("details");
    static APPLICANT_ROUTE = AppRoutingConstants.createRouteToView("applicant");
    static AGENT_ROUTE = AppRoutingConstants.createRouteToView("agent");
    static BURIAL_ROUTE = AppRoutingConstants.createRouteToView("burialdetails");
    static DECEASED_ROUTE = AppRoutingConstants.createRouteToView("deceaseddetails");
    static FAMILY_ROUTE = AppRoutingConstants.createRouteToView("familymemberdetails");
    static FUNERAL_PARLOUR = AppRoutingConstants.createRouteToView("funeralparlour");
    static PROFESSIONAL_BODIES_ROUTE = AppRoutingConstants.createRouteToView("professionalbodies");
    static STAKEHOLDERS_ROUTE = AppRoutingConstants.createRouteToView("stakeholders");
}
